import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { borderRadius, spacing } from '@naf/theme';

export const Wrapper = styled.div`
  margin-bottom: ${spacing.space16};
`;

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  color: ${nafColor.signature.black} !important;

  li {
    margin-bottom: ${spacing.space12};
    color: ${nafColor.signature.black} !important;
  }

  a {
    text-decoration: none;
    display: inline-block;
    line-height: 1.5rem;
    color: ${nafColor.signature.black} !important;
    border-radius: ${spacing.space4};
    padding: ${spacing.space4} ${spacing.space8} ${spacing.space4} ${spacing.space8};

    &:hover {
      text-decoration: none;
      background-color: ${nafColor.signature.yellow40};
      border-radius: ${borderRadius.L};
    }
  }
`;
